import "./App.css";
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Dictionary />
      </header>
    </div>
  );
}

export default App;
